import { Utensils, Pill, Footprints, Box, Bug, Heart, Scissors, Sparkles } from "lucide-react";

export const CARE_TYPES = {
  feeding: { label: "Feeding", icon: Utensils, color: "#F59E0B", bg: "#FFF7E6" },
  medication: { label: "Medication", icon: Pill, color: "#E07A5F", bg: "#FDF2F0" },
  walk: { label: "Walk", icon: Footprints, color: "#10B981", bg: "#ECFDF5" },
  litter: { label: "Litter", icon: Box, color: "#64748B", bg: "#F1F5F9" },
  flea_tick: { label: "Flea / tick", icon: Bug, color: "#0891B2", bg: "#ECFEFF" },
  heartworm: { label: "Heartworm", icon: Heart, color: "#DB2777", bg: "#FDF2F8" },
  grooming: { label: "Grooming", icon: Scissors, color: "#7C3AED", bg: "#F5F3FF" },
  other: { label: "Other", icon: Sparkles, color: "#475569", bg: "#F8FAFC" },
};

export const SPECIES = ["dog", "cat", "rabbit", "guinea pig", "hamster", "bird", "reptile", "fish", "other"];
export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const VET_LINE = "PackLog is a tracking and reminder tool. It never gives medical advice. For any health question, please contact your veterinarian.";
export const PLANS = { monthly: { price: "$3.99", per: "month" }, yearly: { price: "$29", per: "year", note: "Save 39%" } };
